'use client';
import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
var _excluded = ["as", "classPrefix", "className", "children", "query", "renderMark"];
import React from 'react';
import PropTypes from 'prop-types';
import { useClassNames } from "../internals/hooks/index.js";
import { highlightText } from "./utils/highlightText.js";
import { stringifyReactNode } from "../internals/utils/index.js";
function defaultRenderMark(match, index) {
  return /*#__PURE__*/React.createElement("mark", {
    key: index,
    className: "rs-highlight-mark"
  }, match);
}

/**
 *
 * Highlight the matching text in the content.
 *
 * @see https://rsuitejs.com/components/highlight
 */
var Highlight = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var _props$as = props.as,
    Component = _props$as === void 0 ? 'div' : _props$as,
    _props$classPrefix = props.classPrefix,
    classPrefix = _props$classPrefix === void 0 ? 'highlight' : _props$classPrefix,
    className = props.className,
    children = props.children,
    query = props.query,
    _props$renderMark = props.renderMark,
    renderMark = _props$renderMark === void 0 ? defaultRenderMark : _props$renderMark,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  var _useClassNames = useClassNames(classPrefix),
    withClassPrefix = _useClassNames.withClassPrefix,
    merge = _useClassNames.merge;
  var classes = merge(className, withClassPrefix());
  var text = stringifyReactNode(children);
  return /*#__PURE__*/React.createElement(Component, _extends({
    ref: ref,
    className: classes
  }, rest), highlightText(text, {
    query: query,
    renderMark: renderMark
  }));
});
Highlight.displayName = 'Highlight';
Highlight.propTypes = {
  className: PropTypes.string,
  classPrefix: PropTypes.string,
  as: PropTypes.elementType
};
export default Highlight;